// extracted by mini-css-extract-plugin
export default {"root":"LcHik","profileName":"mU0tG","unsubscribeMessage":"bSm2g","cancelButton":"NsXnD","button":"EmKEW","unsubscribeButton":"Q4fUv","avatar":"mX_im"};